// @flow

const roundsSelector = (state: Object) =>
	state.rounds.ordered_ids.map(round_id => state.rounds.by_id[round_id]);

export default roundsSelector;